
import { Component, Prop, Vue } from 'vue-property-decorator';
import { WebsiteComposite } from '@/services/Website/interfaces';

@Component
export default class DeleteWebsitePanel extends Vue {
  @Prop({ type: Object, required: true })
  public composite!: WebsiteComposite;

  @Prop({ type: Boolean, default: false })
  public busy!: boolean;

  @Prop({ type: String, default: '' })
  public errorMessage!: string;

  public confirmedDomain = '';

  public get domain(): string {
    return this.composite.website.domain;
  }

  public get valid(): boolean {
    return this.confirmedDomain.trim() === this.domain;
  }

  public onSubmit(): void {
    if (!this.valid) {
      return;
    }

    this.$emit('submit', { confirmedDomain: this.confirmedDomain.trim() });
  }
}
